module.exports = __webpack_public_path__ + "static/media/open-menu.695956b0.svg";